import { render, staticRenderFns } from "./AudioViewer.vue?vue&type=template&id=5c4be63a&scoped=true&"
import script from "./AudioViewer.vue?vue&type=script&lang=js&"
export * from "./AudioViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4be63a",
  null
  
)

export default component.exports